import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-stone-100 border-b border-stone-200 py-2 px-4 text-center" data-id="element-302">
      <p className="text-stone-800 text-sm md:text-base font-bold" data-id="element-303">
        ⚠️ ATENCIÓN: Oferta de lanzamiento de $6.36 termina hoy (Quedan 14
        cupos).
      </p>
    </div>;
}